module.exports = __webpack_public_path__ + "static/lump-sum-contracts-735db74d979810f8a4818adaa0ea6e52.jpg";